import { render, staticRenderFns } from "./NivelDestaqueCard.vue?vue&type=template&id=3c082e22&scoped=true&lang=pug"
import script from "./NivelDestaqueCard.vue?vue&type=script&lang=js"
export * from "./NivelDestaqueCard.vue?vue&type=script&lang=js"
import style0 from "./NivelDestaqueCard.vue?vue&type=style&index=0&id=3c082e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c082e22",
  null
  
)

export default component.exports